/**
 * @description 防抖/节流 composable，组件卸载时自动 cancel，避免内存泄漏与无效调用
 */
import { onUnmounted } from 'vue'
import { debounce, throttle } from '@/utils'

/**
 * 创建带生命周期清理的防抖函数（适用于表单提交、搜索提交等）
 * @param {Function} fn - 要防抖的函数
 * @param {number} [wait=300] - 等待毫秒数
 * @param {Object} [options] - lodash debounce 选项，常用 { leading: true, trailing: false } 表示仅首次立即执行
 * @returns {Function} 防抖后的函数（含 .cancel()）
 */
export function useDebounceFn(fn, wait = 300, options = {}) {
  const debounced = debounce(fn, wait, options)
  onUnmounted(() => {
    debounced.cancel()
  })
  return debounced
}

/**
 * 创建带生命周期清理的节流函数（适用于 scroll、resize 等高频事件）
 * @param {Function} fn - 要节流的函数
 * @param {number} [wait=16] - 间隔毫秒数，默认约 60fps
 * @param {Object} [options] - lodash throttle 选项
 * @returns {Function} 节流后的函数（含 .cancel()）
 */
export function useThrottleFn(fn, wait = 16, options = {}) {
  const throttled = throttle(fn, wait, options)
  onUnmounted(() => {
    throttled.cancel()
  })
  return throttled
}
